import type { HrSetupEmployeeRow } from "../schemas/hr-setup-employee.schema.ts";

function titleCaseWord(word: string): string {
  const trimmed = word.trim();
  if (trimmed === "") return "";
return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);}

/** Title-cases each name segment and joins with spaces (legacy HR setup list display). */
export function formatOnboardEmployeeName(row: Pick<HrSetupEmployeeRow, "firstName" | "middleName" | "lastName">): string {
  const parts = [row.firstName, row.middleName, row.lastName]
    .filter((p): p is string => typeof p === "string" && p.trim() !== "")
    .map(titleCaseWord);
  return parts.join(" ").trim();
}
